import * as service from "../service";
import { store } from "../../store";
import { controlLoading } from "../../slices/app.slice";
import type { ServiceResponse } from "../types";

export type RejectVerificationParams = {
  student_id: string;
  reject_reason: string;
  document?: "student_card" | "hkid";
};

export type RejectVerificationResult = Record<string, any>;

/**
 * Reject student verification (admin only).
 * Backend: POST /api/student/rejectVerification
 */
export const RejectVerificationAPI = async (
  params: RejectVerificationParams,
): Promise<ServiceResponse<RejectVerificationResult>> => {
  const admin = store.getState().auth.admin;
  try {
    const resp = (await service.call(
      "POST",
      "/api/student/rejectVerification",
      { ...params, admin_id: admin.id },
    )) as ServiceResponse<RejectVerificationResult>;
    if (resp?.status === 0) {
      store.dispatch(controlLoading({ showLoading: false }));
    }
    return resp;
  } catch (err) {
    console.error(`RejectVerificationAPI ${err}`);
    return { status: -1, error: err };
  }
};